import Navbar from "../../components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import ProblemSolution from "./components/ProblemSolution";
import ServicesSection from "./components/ServicesSection";
import WhyChooseUs from "./components/WhyChooseUs";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#070d1a]">
      <Navbar />
      <main>
        <section id="hero">
          <HeroSection />
        </section>
        <ProblemSolution />
        <section id="services">
          <ServicesSection />
        </section>
        <section id="why-us">
          <WhyChooseUs />
        </section>
        <section id="cta">
          <FinalCTA />
        </section>
      </main>
      <Footer />
    </div>
  );
}
